module.exports = __webpack_public_path__ + "assets/images/magenta_sport_7.e3bd38aff4a184bda1096c6da1e21a36.png";